<template>
  <div ref="GLTF" id="GLTF-3D"></div>
</template>

<script>
import { World } from './src/World.js';

export default {
  mounted() {
    this.main();
  },
  methods: {
    async main() {
      const container = this.$refs.GLTF;
      const world = new World(container);

      let options = {
        path: 'https://poster.xdcdn.net/xd-website/homepage/t3arena/model/',
        json: '63kclgt67q28xqfvxdt0f8p8tyi01voq',
        bin: 'sldpw7zpvyh8gyq2lv3wjuqntul95g3h',
        textures: [
          '2oulk38c2jfg3hl5yxz46wxlxl5v4lj2',
          '5q1g75r5ks4ej9rzj3d4rkwdikdsy5r5',
          'h9mlt6qg7slg383z81nd967zwsgky51x',
          'ekbc3bn437ck493ipi4705jwmiq515ki',
          'lar2ytcqwlokdrt3ovopn76x1tyl4r8p',
          'gk5ybwejgihe3w46uj90jmxsuqwks991'
        ]
      };

      await world.init(options);
      world.start();
    }
  }
}
</script>

<style lang="scss" scoped>
#GLTF-3D {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  canvas {
    transform: translate3d(0px, 3vh, 0px) !important;
  }
}
</style>